import { getSourceFeedback, getSourceFeedbackMessageMap } from '../api/GetHistoricalData';
const requestSourceFeedbackType = 'REQUEST_SOURCE_FEEDBACK';
const receiveSourceFeedbackType = 'RECEIVE_SOURCE_FEEDBACK';
const requestSourceFeedbackUpdateType = 'REQUEST_SOURCE_FEEDBACK_UPDATE';
const receiveSourceFeedbackUpdateType = 'RECEIVE_SOURCE_FEEDBACK_UPDATE';
const requestSourceFeedbackTypeMessageMap = 'REQUEST_SOURCE_FEEDBACK_MESSAGE_MAP';
const receiveSourceFeedbackTypeMessageMap = 'RECEIVE_SOURCE_FEEDBACK_MESSAGE_MAP';

const initialState = {
    sourceFeedback: [], sourceFeedbackMessageMap: {}, isLoading: false };

export const actionCreators = {
    requestSourceFeedback: () => async (dispatch) => {
        let store = window.store;
        if (!store.getState().sourceFeedback.isLoading) {
            dispatch({ type: requestSourceFeedbackType });
            if (store.getState().sourceFeedback.sourceFeedback && store.getState().sourceFeedback.sourceFeedback.length == 0) {
                dispatch({ type: requestSourceFeedbackType });
                getSourceFeedback().then(data => {
                    dispatch({ type: receiveSourceFeedbackType, sourceFeedback: data });
                }).catch(ex => {
                    // todo
                });
            }
            else
                dispatch({ type: receiveSourceFeedbackType, sourceFeedback: store.getState().sourceFeedback.sourceFeedback });
        }
    },
    requestSourceFeedbackUpdate: (dispatch, data) => {
        let store = window.store;
        if (store.getState().sourceFeedback.sourceFeedback && store.getState().sourceFeedback.sourceFeedback.length == 0)
            return; // do nothing until we have initial data populated

        dispatch({ type: receiveSourceFeedbackUpdateType, sourceFeedback: data });
    },
    requestSourceFeedbackMessageMap: () => async (dispatch) => {
        dispatch({ type: requestSourceFeedbackTypeMessageMap });

        getSourceFeedbackMessageMap().then(data => {
            dispatch({ type: receiveSourceFeedbackTypeMessageMap, sourceFeedbackMessageMap: data });
        }).catch(ex => {
            // todo
        });
    },
};  

//export const manualDispatchActions = {
//    getSourceFeedbackManual: (dispatch) => {
//        dispatch({ type: requestSourceFeedbackType });

//        getSourceFeedback().then(data => {
//            dispatch({ type: receiveSourceFeedbackType, sourceFeedback: data });
//        }).catch(ex => {
//            // todo
//        });            
//    }
//}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestSourceFeedbackType ||
        action.type === requestSourceFeedbackUpdateType ||
        action.type === requestSourceFeedbackTypeMessageMap) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveSourceFeedbackTypeMessageMap ||
        action.type === receiveSourceFeedbackType) {
        return {
            ...state,
            ...action,
            isLoading: false
        };
    }

    if (action.type === receiveSourceFeedbackUpdateType) {
        return {
            ...state,
            sourceFeedback: [...state.sourceFeedback, ...action.sourceFeedback],
            isLoading: false
        };
    }

    return state;
};
